import { head } from 'lodash/fp';

import { Article } from '../../../../src/client/types/__codegen__/sanity/graphql';
import { INSURANCE_TYPES_WITH_HEALTH } from '../../../../src/client/pages/insurance/constants';
import BlogDetail from '../../../../src/client/pages/blog-detail';
import constants from '../../../../src/client/ahm-constants';
import getArticleTypeProps from '../../../utils/get-article-type-props';
import getShouldSkipClientSideRequest from '../../../../src/client/utils/get-should-skip-client-side-request';
import getStaticPathsForArticles from '../../../utils/get-static-paths-for-articles';
import RedirectAdapter from '../../../../src/client/utils/redirect-adapter';
import useGetArticle from '../../../../src/client/pages/blog-detail/hooks/use-get-article';

type ArticlesPageProps = {
  content: Article[] | null;
  slug: string;
};

const { URLS } = constants;

const ArticlesPage = ({ content, slug }: ArticlesPageProps) => {
  const shouldSkip = getShouldSkipClientSideRequest();

  const {
    data: clientData,
    error,
    isLoading,
  } = useGetArticle({
    options: {
      skip: shouldSkip,
    },
    slug,
  });

  const articleData = shouldSkip ? head(content) : head(clientData);

  if (!isLoading && (error || !articleData)) {
    return <RedirectAdapter to={URLS.SALES.ERROR_500} />;
  }

  return <BlogDetail blogPost={articleData} />;
};

export const getStaticPaths = () => getStaticPathsForArticles([INSURANCE_TYPES_WITH_HEALTH.HEALTH]);

export const getStaticProps = getArticleTypeProps;

export default ArticlesPage;
